import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Defer PostHog initialization to avoid blocking initial render and reduce TBT
const initPostHog = () => {
  import('posthog-js').then(({ default: posthog }) => {
    const apiKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
    const apiHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
    if (apiKey) {
      posthog.init(apiKey, {
        api_host: apiHost,
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') posthog.debug();
        },
        capture_pageview: true,
        capture_pageleave: true,
      });
    }
  });
};

// Initialize PostHog after the page becomes interactive
if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initPostHog, { timeout: 4000 });
  } else {
    setTimeout(initPostHog, 3000);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
